export const VEHICLE_TYPES = [
  // Véhicules à moteur
  { id: 'racing_car',   label: 'Bolide',      emoji: '🏎'  },
  { id: 'car',          label: 'Voiture',     emoji: '🚗'  },
  { id: 'taxi',         label: 'Taxi',        emoji: '🚕'  },
  { id: 'bus',          label: 'Bus',         emoji: '🚌'  },
  { id: 'motorcycle',   label: 'Moto',        emoji: '🏍'  },
  { id: 'scooter',      label: 'Scooter',     emoji: '🛵'  },
  { id: 'ambulance',    label: 'Ambulance',   emoji: '🚑'  },
  { id: 'fire_truck',   label: 'Pompiers',    emoji: '🚒'  },
  { id: 'truck',        label: 'Camion',      emoji: '🚛'  },
  { id: 'tractor',      label: 'Tracteur',    emoji: '🚜'  },
  { id: 'pickup',       label: 'Pickup',      emoji: '🛻'  },
  { id: 'tuk_tuk',      label: 'Tuktuk',      emoji: '🛺'  },
  // Propulsion humaine
  { id: 'bicycle',      label: 'Vélo',        emoji: '🚲'  },
  { id: 'kick_scooter', label: 'Trottinette', emoji: '🛴'  },
  { id: 'skateboard',   label: 'Skate',       emoji: '🛹'  },
  { id: 'roller',       label: 'Roller',      emoji: '🛼'  },
  // Volants
  { id: 'rocket',       label: 'Fusée',       emoji: '🚀'  },
  { id: 'ufo',          label: 'OVNI',        emoji: '🛸'  },
  { id: 'helicopter',   label: 'Hélico',      emoji: '🚁'  },
  { id: 'airplane',     label: 'Avion',       emoji: '✈️'  },
  // Rails
  { id: 'train',        label: 'Locomotive',  emoji: '🚂'  },
  { id: 'bullet_train', label: 'TGV',         emoji: '🚄'  },
  // Nautiques
  { id: 'sailboat',     label: 'Voilier',     emoji: '⛵'  },
  { id: 'speedboat',    label: 'Hors-bord',   emoji: '🚤'  },
  { id: 'canoe',        label: 'Canoë',       emoji: '🛶'  },
  // Animaux (fun !)
  { id: 'horse',        label: 'Cheval',      emoji: '🐎'  },
  { id: 'unicorn',      label: 'Licorne',     emoji: '🦄'  },
  { id: 'cheetah',      label: 'Guépard',     emoji: '🐆'  },
  { id: 'zebra',        label: 'Zèbre',       emoji: '🦓'  },
  { id: 'kangaroo',     label: 'Kangourou',   emoji: '🦘'  },
  { id: 'eagle',        label: 'Aigle',       emoji: '🦅'  },
  { id: 'penguin',      label: 'Pingouin',    emoji: '🐧'  },
  { id: 'duck',         label: 'Canard',      emoji: '🦆'  },
  { id: 'crocodile',    label: 'Croco',       emoji: '🐊'  },
  { id: 'turtle',       label: 'Tortue',      emoji: '🐢'  },
  { id: 'snail',        label: 'Escargot',    emoji: '🐌'  },
  { id: 'giraffe',      label: 'Girafe',      emoji: '🦒'  },
  { id: 't_rex',        label: 'T-Rex',       emoji: '🦖'  },
  { id: 'diplodocus',   label: 'Diplodocus',  emoji: '🦕'  },
  { id: 'dragon',       label: 'Dragon',      emoji: '🐉'  },
  // Personnages
  { id: 'robot',        label: 'Robot',       emoji: '🤖'  },
  { id: 'alien',        label: 'Alien',       emoji: '👾'  },
  { id: 'astronaut',    label: 'Astronaute',  emoji: '🧑‍🚀' },
  { id: 'superhero',    label: 'Super-héros', emoji: '🦸'  },
  { id: 'wizard',       label: 'Sorcier',     emoji: '🧙'  },
  { id: 'ghost',        label: 'Fantôme',     emoji: '👻'  },
]

export const KART_COLORS = [
  '#E53E3E','#3182CE','#38A169','#D69E2E',
  '#805AD5','#DD6B20','#00B5D8','#ED64A6',
]

export const BONUS_TYPES = {
  BANANA:   { id: 'banana',  label: 'Banane',   emoji: '🍌', rarity: 'common'  },
  SHELL:    { id: 'shell',   label: 'Coquille', emoji: '🐚', rarity: 'common'  },
  BOMB:     { id: 'bomb',    label: 'Bombe',    emoji: '💣', rarity: 'rare'    },
  HOOK:     { id: 'hook',    label: 'Crochet',  emoji: '🪝', rarity: 'common'  },
  TURBO:    { id: 'turbo',   label: 'Turbo',    emoji: '🚀', rarity: 'common'  },
  SHIELD:   { id: 'shield',  label: 'Bouclier', emoji: '🛡', rarity: 'medium'  },
  STAR:     { id: 'star',    label: 'Étoile',   emoji: '⭐', rarity: 'rare'    },
  FREEZE:   { id: 'freeze',  label: 'Gel',      emoji: '❄️', rarity: 'rare'    },
  WAND:     { id: 'wand',    label: 'Baguette', emoji: '🪄', rarity: 'common'  },
}

// Durées des effets actifs (en secondes)
export const BONUS_DURATIONS = {
  shield: 30,
  star:   60,
  freeze: 12,
}

// Poids pour le tirage aléatoire (mode classique)
export const BONUS_WEIGHTS = [
  { id: 'wand',   weight: 18 },
  { id: 'banana', weight: 16 },
  { id: 'shell',  weight: 16 },
  { id: 'hook',   weight: 14 },
  { id: 'turbo',  weight: 14 },
  { id: 'shield', weight: 14 },
  { id: 'bomb',   weight: 10 },
  { id: 'star',   weight:  9 },
  { id: 'freeze', weight:  6 },
]

// Poids pour le tirage aléatoire (mode solo — uniquement les bonus solo-compatibles)
export const BONUS_WEIGHTS_SOLO = [
  { id: 'turbo', weight: 50 },
  { id: 'wand',  weight: 50 },
]

export const SPEED_CONFIG = {
  DEFAULT_THRESHOLD_V2: 2,
  DEFAULT_THRESHOLD_V3: 5,
  ADVANCE: { 1: 1, 2: 2, 3: 3 },
}

export const GAME_DEFAULTS = {
  LAPS:           1,
  CELLS_PER_LAP:  20,
  TIMER_MAX:      30,
  TIMER_MIN:      5,
  MAX_PLAYERS:    40,
  MAX_BONUS_HELD: 1,
  POLLING_MS:     2000,
}

export const INACTIVITY_THRESHOLD_SECONDS = 90

export const MIN_CIRCUIT_CASES = 15
export const MAX_CIRCUIT_CASES = 80
export const BONUS_RATIO = 0.2
